module.exports = __webpack_public_path__ + "img/trail_yellow.gif";